module.exports = __webpack_public_path__ + "static/stack-my-bch-up-d51d5f766d8aea944d424440db8dcbae.mp3";